import controller from './organization-settings.controller';

const template = require('./organization-settings.html');

export default {
    controller,
    template
};
